import { QueueExecutionResponse } from "@/shared/Executions/models/QueueExecutionResponse";
import { QueueExecutionArgs } from "@/shared/Executions/models/QueueExecutionArgs";
import { AxiosResponse } from "axios";
import { InjectableService } from "@/shared/services/InjectableService";
import { AdvancedAnalysis } from "../models/AdvancedAnalysis";
import { GetAdvancedAnalysisArgs } from "../models/GetAdvancedAnalysisArgs";
import { GetExecutionConfigArgs } from "@/shared/Executions/models/GetExecutionConfigArgs";
import { IExecutionApiService } from "@/shared/Executions/services/ExecutionApiService";


export interface IAdvancedAnalysisApiService {
  processAdvancedAnalysis: (args: QueueExecutionArgs) => Promise<AxiosResponse<QueueExecutionResponse>>;
  getAdvancedAnalysis: (args: GetAdvancedAnalysisArgs) => Promise<AdvancedAnalysis>
}

export class AdvancedAnalysisApiService extends InjectableService implements IAdvancedAnalysisApiService {

  static readonly injectableKey = 'IAdvancedAnalysisApiService';

  get injectableKey() {
    return (this.constructor as typeof AdvancedAnalysisApiService).injectableKey;
  }

  constructor(private readonly _executionApiService: IExecutionApiService) {
    super()
  }

  public async processAdvancedAnalysis(args: QueueExecutionArgs): Promise<AxiosResponse<QueueExecutionResponse>> {

    if (args == null) throw Error("args are required!");

    return await this._executionApiService.queueExecution(args);

  }

  public async getAdvancedAnalysis(args: GetAdvancedAnalysisArgs): Promise<AdvancedAnalysis> {

    const getExecutionConfigArgs = new GetExecutionConfigArgs({ userId: args.userId, tenantId: args.tenantId, executionId: args.executionId });

    const getExecutionConfigReponse = await this._executionApiService.getExecutionConfig(getExecutionConfigArgs);
    //TODO: trnaslte between GetExecutionConfigReponse and AdvancedAnalysis?
    return getExecutionConfigReponse?.data! as AdvancedAnalysis;

  }

}
